import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFetchMyPermissions } from 'gql/employee'
import { SettingsWrapper } from 'pages/SettingsPage/index'
import { useFetchBranches, useFetchSchedules } from '@expane/data'
import { BranchBlock } from './BranchBlock'
import { treeMenuClassName } from 'ui/styles'
import { onChangeSingleTreeMenu } from 'ui/TreeMenu/logic.onChange'
import { TreeMenu, TreeMenuItem } from 'ui/TreeMenu'
import { useOpenBranchCreateDialog } from 'widgets/BranchCreateDialog'
import { stopEnterPropagation } from '@expane/ui'
import { IoAddCircleOutline } from 'react-icons/io5'
import { useBusinessModulesSettings } from '@expane/logic/modules'

export const BranchesSettings: FC = () => {
  const { t } = useTranslation()
  const [selectedItem, setSelectedItem] = useState<TreeMenuItem>()

  const { openDialog: openBranchCreateDialog, dialog: branchCreateDialog } =
    useOpenBranchCreateDialog()

  const { data: branches } = useFetchBranches()
  const { data: myPermissions } = useFetchMyPermissions()
  const { data: schedules } = useFetchSchedules()

  const { getModuleSetting } = useBusinessModulesSettings()

  if (!branches || !myPermissions || !schedules) return null

  const isOneBranch = branches.length === 1

  const selectedBranch = branches.find(branch => branch.id === selectedItem?.id)

  const isBranchesEnabled = getModuleSetting('branches')

  return (
    <SettingsWrapper>
      <div className="mb-4 pb-4 border-b border-gray-200 dark:border-gray-600 max-w-full">
        <div className="flex items-center gap-1">
          <h1 className="text-lg text-gray-500 dark:text-gray-300 font-medium">
            {t('branch.name')}
          </h1>

          {isBranchesEnabled && (
            <button
              onKeyDown={stopEnterPropagation}
              onClick={openBranchCreateDialog}
              className="text-primary-500 hover:text-primary-700 hover:dark:text-primary-600 rounded-full focus:ring-1 ring-primary-500"
            >
              <IoAddCircleOutline size="1.6rem" />
            </button>
          )}
        </div>
      </div>

      {isOneBranch ? (
        <BranchBlock
          className={branchBlockWidth}
          branch={branches[0]}
          schedules={schedules}
          myPermissions={myPermissions}
        />
      ) : (
        <div className="flex">
          <TreeMenu
            type="SinglePickMode"
            className={treeMenuClassName + ' w-56'}
            items={branches}
            selected={selectedItem}
            onSelected={item => setSelectedItem(onChangeSingleTreeMenu(item, selectedItem))}
            openSwitch
            isSearch={false}
          />

          {selectedBranch ? (
            <BranchBlock
              key={selectedBranch.id}
              className={branchBlockWidth + ' ml-4'}
              schedules={schedules}
              myPermissions={myPermissions}
              branch={selectedBranch}
            />
          ) : (
            <div className={branchBlockWidth + ' ml-4 flex flex-centered'}>
              <p className="text-main-color">{t('branch.selectBranchFromList')}</p>
            </div>
          )}
        </div>
      )}

      {branchCreateDialog}
    </SettingsWrapper>
  )
}

const branchBlockWidth = 'w-152'
